import { Button, Icon, IndexTable, InlineStack, LegacyCard, Text, Tooltip } from '@shopify/polaris';
import { ChevronDownMinor, ChevronUpMinor, InfoMinor, StatusActiveMajor } from '@shopify/polaris-icons';
import { t } from 'i18next';
import React, { useState } from 'react';

const PricingComparison = (props: any) => {
    const { choosePlan, carouselRef } = props;
    const [openColl, setOpenColl] = useState([true, true, true, true]);
    const activeMajor = <Icon source={StatusActiveMajor} tone='success' />;
    const marketingServicesData = [
        {
            id: '01',
            planFeatures: <Text as='span' variant='bodyLg' fontWeight='semibold'>{t("Account Management")}</Text>,
            free: '',
            beginner: '',
            growth: '',
            enterprise: <Icon source={openColl[0] ? ChevronUpMinor : ChevronDownMinor} />,
        },
        {
            id: '02',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon Account Connection")}</Text>,
            free: "1",
            beginner: t("Unlimited"),
            growth: t("Unlimited"),
            enterprise: t("Unlimited")
        },
        {
            id: "03",
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Multilingual Support")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '04',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon Account Health Report")}</Text>,
            free: "-",
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '05',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Multiple Warehouse Mapping")}</Text>,
            free: '-',
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '06',
            planFeatures: <Text as='span' variant='bodyLg' fontWeight='semibold'>{t("Product Management")}</Text>,
            free: '',
            beginner: '',
            growth: '',
            enterprise: <Icon source={openColl[1] ? ChevronUpMinor : ChevronDownMinor} />,
        },
        {
            id: '07',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("List Products on Amazon")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '08',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Add Offer Listing to Existing Products")}</Text>
                <Tooltip content={t("Add your offers to existing products without creating new listings.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '09',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Real-Time Inventory & Price Sync")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '10',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Bulk Product Upload via Category Templates")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '11',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Set Price Sync Rules")}</Text>
                <Tooltip content={t("Stay competitive and maximize profits by setting business pricing, minimum price thresholds, and more for your Amazon listings.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,

            free: '-',
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '12',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Set Inventory Sync Rules")}</Text>
                <Tooltip content={t("Prevent overselling and streamline stock management with custom, fixed, threshold, and reserve inventory options.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: '-',
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '13',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Bulk Edit Product Information")}</Text>,
            free: '-',
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '14',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Bulk Product Updates via CSV")}</Text>,
            free: '-',
            beginner: '-',
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '15',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("FBA & FBM Listing Creation")}</Text>,
            free: '-',
            beginner: '-',
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '16',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Remove Image Background")}</Text>
                <Tooltip content={t("Ensure compliance with Amazon’s requirements by removing backgrounds from product images for a clean, professional look.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: '-',
            beginner: '-',
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '17',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Integrated Currency Converter")}</Text>,
            free: '-',
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '18',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Shopify Metafield Support for Amazon Listing")}</Text>
                <Tooltip content={t("Shopify metafields let you add extra product details beyond standard fields, helping create more informative listings that improve discoverability.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: '-',
            beginner: '-',
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '19',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Automated Product Linking")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '20',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Product Optimizer Tool")}</Text>
                <Tooltip content={t("Enhance Amazon listings with AI recommendations for titles, keywords, and description")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: '-',
            beginner: '-',
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '21',
            planFeatures: <Text as='span' variant='bodyLg' fontWeight='semibold'>{t("Order Management")}</Text>,
            free: '',
            beginner: '',
            growth: '',
            enterprise: <Icon source={openColl[2] ? ChevronUpMinor : ChevronDownMinor} />,
        },
        {
            id: '22',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Auto Sync Orders")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '23',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Shipping Carrier Mapping")}g</Text>,
            free: '-',
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '24',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Set Order Sync Rules")}</Text>
                <Tooltip content={t("Customize how your Amazon orders sync by setting rules for order import, fulfillment, and status updates.")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: '-',
            beginner: '-',
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '25',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Auto-Sync Order Cancellation")}</Text>,
            free: "-",
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '26',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Auto-Sync Return & Refund")}</Text>,
            free: "-",
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '27',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Sync FBA & FBM Orders")}</Text>,
            free: activeMajor,
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '28',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Sync POD Orders")}</Text>,
            free: "-",
            beginner: "-",
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '29',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Add Custom Tags in Orders")}</Text>,
            free: "-",
            beginner: "-",
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '30',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Modify Shopify Order Name")}</Text>,
            free: "-",
            beginner: activeMajor,
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '31',
            planFeatures: <Text as='span' variant='bodyLg' fontWeight='semibold'>{t("Amazon Growth Tools")}</Text>,
            free: "",
            beginner: "",
            growth: "",
            enterprise: <Icon source={openColl[3] ? ChevronUpMinor : ChevronDownMinor} />,
        },
        {
            id: '32',
            planFeatures: <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon Notifications")}</Text>,
            free: "-",
            beginner: "-",
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '33',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon Vine Orders")}</Text>
                <Tooltip content={t("Orders fulfilled through Amazon Vine reviews program")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>  </InlineStack>,
            free: "-",
            beginner: "-",
            growth: "-",
            enterprise: activeMajor
        },
        {
            id: '34',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon MLI")}</Text>
                <Tooltip content={t("Ship orders from multiple warehouses")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: "-",
            beginner: "-",
            growth: activeMajor,
            enterprise: activeMajor
        },
        {
            id: '35',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon BuyShipping")}</Text>
                <Tooltip content={t("Buy and print shipping labels via Amazon")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: "-",
            beginner: "-",
            growth: "-",
            enterprise: activeMajor
        },
        {
            id: '36',
            planFeatures: <InlineStack gap={"050"}>
                <Text as='span' variant='bodyMd' fontWeight='regular'>{t("Amazon Business")}</Text>
                <Tooltip content={t("Sell to B2B Buyers")}><span><Icon source={InfoMinor} tone='subdued' /></span></Tooltip>
            </InlineStack>,
            free: "-",
            beginner: "-",
            growth: "-",
            enterprise: activeMajor
        },
        {
            id: '37',
            planFeatures: <></>,
            free: <Button size='medium' onClick={() => {
                window.scroll({
                    top: 50,
                    behavior: "smooth",
                });
                carouselRef.current.goTo(4)
            }

            } >{t("Get Started")}</Button>,
            beginner: <Button size='medium' onClick={() => window.scroll({
                top: 50,
                behavior: "smooth",
            })} >{t("Subscribe")}</Button>,
            growth: <Button onClick={() => window.scroll({
                top: 50,
                behavior: "smooth",
            })} size='medium'>{t("Subscribe")}</Button>,
            enterprise: <Button onClick={() => window.open("https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g7NeU-DtavtyOoK6p_Vz_yix_xRdVCebaqHDOmQSxNt1J2_vO5ZaeqC_oDURH15RoA2-LGV2M", "__blank")} size='medium'>{t("Contact Us")}</Button>,
        }
    ];

    const RenderRowData = ({ id, planFeatures, free, beginner, growth, enterprise }: any,
        index: any) => {
        return (
            <IndexTable.Row id={id} key={id} position={index}>
                <IndexTable.Cell>{planFeatures}</IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{free}</div></IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{beginner}</div></IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{growth}</div></IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{enterprise}</div></IndexTable.Cell>
            </IndexTable.Row>
        )
    }

    const rowMarkup1 = marketingServicesData.slice(1, 5).map(RenderRowData);
    const rowMarkup2 = marketingServicesData.slice(6, 20).map(RenderRowData);
    const rowMarkup3 = marketingServicesData.slice(21, 30).map(RenderRowData);
    const rowMarkup4 = marketingServicesData.slice(31, 36).map(RenderRowData);
    const rowMarkup5 = marketingServicesData.slice(36).map(RenderRowData);

    const handleToggleClick = (ind: any) => {
        let temp = [...openColl];
        temp[ind] = temp[ind] === false ? true : false;
        setOpenColl(temp);
    }

    const renderCellData = (clickInd: number, rowInd: number) => {
        return (
            <tr onClick={() => handleToggleClick(clickInd)} className="Polaris-IndexTable__TableRow Polaris-IndexTable__TableRow--unclickable custom-pricing-comparison-collapsible">
                <IndexTable.Cell>
                    {marketingServicesData[rowInd].planFeatures}
                </IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{marketingServicesData[rowInd].free}</div></IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{marketingServicesData[rowInd].beginner}</div></IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{marketingServicesData[rowInd].growth}</div></IndexTable.Cell>
                <IndexTable.Cell><div className='text-align-center'>{marketingServicesData[rowInd].enterprise}</div></IndexTable.Cell>
            </tr>
        )
    }

    return (
        <div className='custom-pricing-comparison-table'>
            <LegacyCard>
                <IndexTable
                    itemCount={marketingServicesData.length}
                    headings={[
                        { title: t("Plan Features"), alignment: "start" },
                        { title: t('Free'), alignment: "center" },
                        { title: t('Beginner'), alignment: "center" },
                        { title: t('Growth'), alignment: "center" },
                        { title: t('Enterprise'), alignment: "center" },
                    ]}
                    selectable={false}
                >
                    {renderCellData(0, 0)}
                    {openColl[0] && rowMarkup1}
                    {renderCellData(1, 5)}
                    {openColl[1] && rowMarkup2}
                    {renderCellData(2, 20)}
                    {openColl[2] && rowMarkup3}
                    {renderCellData(3, 30)}
                    {openColl[3] && rowMarkup4}
                    {rowMarkup5}
                </IndexTable>
            </LegacyCard>
        </div>
    )
}

export default PricingComparison;